:host {
  padding: 0;
  width: 100%;
  font-size: 1rem;
  background-color: var(--sdx-color-aluminum);
  box-shadow: -1px -1px 2px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  display: block;

  .notifications__container {
    background-color: var(--sdx-color-aluminum);
  }
}

.inlay.notifications {
  padding: 2rem 0 1rem;

  .no-activities-message {
    padding: 0 16px;
    text-align: center;

    p {
      margin-bottom: 0;
      margin-top: 8px;
    }

    a {
      font-size: 18px;
      display: inline-block;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  a {
    color: var(--sdx-color-int-blue);
  }

  .activities--loading {
    text-align: center;
    padding-bottom: 1.2rem;
  }

  .inlay {
    // From sdxcode/stylesheets/sdx/base/core
    * {
      &,
      &::before,
      &::after {
        box-sizing: inherit;
      }
    }

    margin: 0 auto;
    padding: 0 1%;
    width: 100%;
    position: relative;
    box-sizing: border-box;

    .notification--content {
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      flex-direction: column;
      scs-notification-box-light {
        width: 100%;
      }

      .notification {
        // From sdxcode/stylesheets/sdx/base/core
        * {
          &,
          &::before,
          &::after {
            box-sizing: inherit;
          }
        }

        margin-bottom: 1rem;
        background-color: var(--sdx-color-sc-white);
        border-top: solid 4px var(--sdx-color-int-blue);
        color: var(--sdx-color-gray);

        .header-section {
          padding: 16px 16px 10px 16px;
          display: flex;
          align-items: center;

          .icon {
            margin-right: 8px;
          }
          div.notification-message {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .icon-094-warning {
          color: var(--sdx-color-int-orange);
        }

        &--success {
          border-top-color: var(--sdx-color-int-green);
        }

        &--error {
          border-top-color: var(--sdx-color-int-orange);
        }

        &--agent {
          border-top-color: var(--sdx-color-sc-navy);
        }

        &.no-hover {
          cursor: default;
          background: var(--sdx-color-horizon);
        }

        transition: background 200ms cubic-bezier(0.4, 0, 0.2, 1);
      }
    }

    .further-activities {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      margin-bottom: 13px;
    }

    // From sdxcode/stylesheets/sdx/link/link
    a:link {
      position: relative;

      transition:
        border-bottom 200ms cubic-bezier(0.4, 0, 0.6, 1),
        color 200ms cubic-bezier(0.4, 0, 0.6, 1);

      outline: none;

      border-bottom: 1px solid transparent;

      cursor: pointer;
      text-decoration: none;

      color: var(--sdx-color-int-blue);

      &:hover,
      &:focus {
        border-bottom: 1px solid var(--sdx-color-int-blue--active);
        color: var(--sdx-color-int-blue--active);
      }

      &:focus {
        outline: none;
      }
    }
  }
}
